import React, { memo, useCallback } from "react";
import { Text } from "@chakra-ui/react";

import colors from "app/colors";
import { HelpIcon, LinkedConversationIcon } from "modules/icons";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import {
  MODAL_TYPE,
  useOverlay,
} from "modules/providers/overlay-provider/overlay-provider";

const LinkedConversationHelpButton = () => {
  const { openModal } = useOverlay();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.HELP,
        helpModal: {
          icon: <LinkedConversationIcon boxSize={14} />,
          title: "Linked Conversations",
          message: (
            <>
              <Text fontSize={13}>
                Link conversations together to relate them to one another and
                share information between them.
              </Text>
              <Text fontSize={13}>
                Links between conversations can only be seen by those users who
                have access to both conversations.
              </Text>
            </>
          ),
        },
      });
    },
    [openModal],
  );

  return (
    <CircularIconButton
      icon={<HelpIcon boxSize={4} fill={colors.gray40} />}
      minW={6}
      h={6}
      aria-label="help info"
      onClick={onClick}
    />
  );
};

export default memo(LinkedConversationHelpButton);
